import { Loading } from "Utils/Loading";
import { TableItem } from "./TableItem";

interface TabledataProps {
  units: any[];
  loading: boolean;
  handleSorting: (fieldName: string) => void;
}

export const Tabledata = ({
  units,
  loading,
  handleSorting,
}: TabledataProps) => {
  return (
    <div className="page-content page-content-list">
      <table className="table-content small-separate details">
        <thead>
          <tr>
            <th>
              Nome da Unidade
              <button
                type="button"
                className="sort-buttons"
                onClick={() => handleSorting("name")}
              >
                ↓↑
              </button>
            </th>
            <th>
              Região
              <button
                type="button"
                className="sort-buttons"
                onClick={() => handleSorting("region_id")}
              >
                ↓↑
              </button>
            </th>
            <th>Endereço</th>
            <th>
              Cidade
              <button
                type="button"
                className="sort-buttons"
                onClick={() => handleSorting("city")}
              >
                ↓↑
              </button>
            </th>
            <th>Status</th>
            <th>
              Tipo da Unidade
              <button
                type="button"
                className="sort-buttons"
                onClick={() => handleSorting("type")}
              >
                ↓↑
              </button>
            </th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {units?.length > 0 && !loading ? (
            units?.map((item) => <TableItem key={item.id} item={item} />)
          ) : (
            <tr>
              <td colSpan={7} className="text-center text-purple">
                {loading ? (
                  <Loading />
                ) : (
                  "Oops! Parece que nada foi encontrado..."
                )}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
